import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';
import type { HttpError } from '@Services/errors/errorType.ts';

export const PhoneErrorMap = {
  INVALID_PHONE_NUMBER: { errorCode: 4010, errorType: ErrorType.BUSINESS_LOGIC },
  PHONE_NUMBER_VOIP: { errorCode: 4302, errorType: ErrorType.BUSINESS_LOGIC },
  PHONE_NUMBER_NOT_US: { errorCode: 43021, errorType: ErrorType.BUSINESS_LOGIC },
  PHONE_NUMBER_LANDLINE: { errorCode: 4304, errorType: ErrorType.BUSINESS_LOGIC },
  NEW_PHONE_EXISTS: { errorCode: 4350, errorType: ErrorType.BUSINESS_LOGIC },
  PHONE_VALIDATION_RESTRICTED: { errorCode: 4399, errorType: ErrorType.BUSINESS_LOGIC },
  MFA_CODE_IS_INVALID: { errorCode: 40032, errorType: ErrorType.BUSINESS_LOGIC },
  AUTHORIZED_USER_PHONE_VALIDATION_ERROR: { errorCode: 50721, errorType: ErrorType.TECHNICAL },
} as const satisfies Record<string, HttpError>;

export const getPhoneErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      PhoneErrorMap.NEW_PHONE_EXISTS.errorCode,
      {
        errorCode: PhoneErrorMap.NEW_PHONE_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.PHONE_VALIDATION_RESTRICTED.errorCode,
      {
        errorCode: PhoneErrorMap.PHONE_VALIDATION_RESTRICTED.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.INVALID_PHONE_NUMBER.errorCode,
      {
        errorCode: PhoneErrorMap.INVALID_PHONE_NUMBER.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.PHONE_NUMBER_VOIP.errorCode,
      {
        errorCode: PhoneErrorMap.PHONE_NUMBER_VOIP.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.PHONE_NUMBER_NOT_US.errorCode,
      {
        errorCode: PhoneErrorMap.PHONE_NUMBER_NOT_US.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.PHONE_NUMBER_LANDLINE.errorCode,
      {
        errorCode: PhoneErrorMap.PHONE_NUMBER_LANDLINE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.MFA_CODE_IS_INVALID.errorCode,
      {
        errorCode: PhoneErrorMap.MFA_CODE_IS_INVALID.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.MFA_OTP,
        callBack: () => {},
      },
    ],
    [
      PhoneErrorMap.AUTHORIZED_USER_PHONE_VALIDATION_ERROR.errorCode,
      {
        errorCode: PhoneErrorMap.AUTHORIZED_USER_PHONE_VALIDATION_ERROR.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
        callBack: () => {},
      },
    ],
  ]);
};
